<template>
  <div>
    <pclogin></pclogin>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
    };
  },
  computed:{
  },
  watch:{
  },
  created(){},
  methods: {}
}
</script>

<style lang='less' scoped>

</style>
